import { TypeReferenceComponent } from '../components/type-reference/type-reference.component'
import { TitleBoxComponent } from './title-box/title-box.component'
import { NgModule } from '@angular/core'

import { CodeEditorComponent } from './code-editor/code-editor.component'

import { SafeHtmlPipe } from './safe-html.pipe'
import { TextOrInputComponent } from '../components/text-or-input/text-or-input.component'
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component'
import { PromptDialogComponent } from '../dialogs/prompt-dialog/prompt-dialog.component'
import { HelpComponent } from './help/help.component'
import { MaterialModules, NgSharedModule } from '@lg/ng-shared'
import { NgxRerenderModule } from 'ngx-rerender'
import { AutosizeModule } from 'ngx-autosize'
import { BaseChartDirective } from 'ng2-charts'
import {
	EditorFrameComponent,
	EditorFrameTopRightDirective,
} from './editor-frame/editor-frame.component'
import { AngularSplitModule } from 'angular-split'
import '@otplib/preset-browser/buffer.js'

const importExports = [
	NgSharedModule,
	BaseChartDirective,
	...MaterialModules,
	AngularSplitModule,
]

@NgModule({
	declarations: [
		CodeEditorComponent,
		TitleBoxComponent,
		SafeHtmlPipe,
		TextOrInputComponent,
		TypeReferenceComponent,
		ConfirmationDialogComponent,
		PromptDialogComponent,
		HelpComponent,
		EditorFrameComponent,
		EditorFrameTopRightDirective,
	],
	imports: [...importExports],
	exports: [
		...importExports,
		CodeEditorComponent,
		TitleBoxComponent,
		SafeHtmlPipe,
		TextOrInputComponent,
		TypeReferenceComponent,
		HelpComponent,
		NgxRerenderModule,
		AutosizeModule,
		BaseChartDirective,
		EditorFrameComponent,
	],
})
export class SharedStudioModule {}
